import Vue from 'vue'
import VueRouter from 'vue-router'
import vuex from './store'
import {
  DEFAULT_LANG,
  GET_LOCALE_FIRST_PART,
  LANGUAGE_LIST
} from "./config/locale_config";

Vue.use(VueRouter)

export const ROUTES_NAMES = {
  login: 'login',
  register: 'register',
  verify_email: 'verify_email',
  forgot_password: 'forgot_password',
  forgot_password_reset: 'forgot-password-reset',
  dashboard: 'dashboard',
  my_vacation_calendar: 'my_vacation_calendar',
  vacation_calendar: 'vacation_calendar',
  public_holidays_calendar: 'public_holidays_calendar',
  my_committee: 'my_committee',
  page_404: 'page_404',
  users: 'users',
  user: 'user',
  user_equipment: 'user_equipment',
  profile: 'profile',
  committees: 'committees',
  committee: 'committee',
  export: 'export',
  daily_report: 'daily_report',
  report_fact: 'report_fact',
  articles_parent: 'articles',
  articles: 'articles_list',
  editArticle: 'edit_article',
  article_categories: 'article_categories',
  editArticleCategory: 'edit_article_category',
  blog: 'blog',
  article: 'article',
  files: "files",
  documents_parent: 'documents_parent',
  document: 'document',
  editDocument: 'edit_document',
  document_categories: 'document_categories',
  editDocumentCategory: 'edit_document_category',
  benefit_parent: 'benefits',
  benefit_packages: 'benefit_packages',
  benefit_package: 'benefit_package',
  benefit_cookies: 'benefit_cookies',
  benefit_cookie: 'benefit_cookie',
  belt_benefit: 'belt_benefit',
  trash: 'trash',
  trashed: 'trashed',
  statistic: 'statistic',
  company_equipments: 'company_equipments',
  company_equipment: 'company_equipment'
}

export const MENU_TRANSLATES = {
  blog: 'blog'
}

export const LOCALE_PARAM = 'locale'

export const ROUTES = [
  {
    path: '/',
    redirect: `/${DEFAULT_LANG}`,
    meta: {
      redirect: true,
    },
  },
  {
    path: '/login',
    name: ROUTES_NAMES.login,
    component: require('./components/layouts/auth/LoginLayout.vue').default,
    meta: {
      title: "Login",
    },
    beforeEnter(to, from, next) {
      if (vuex.getters.getUser) {
        vuex.getters.getUserMailVerified
          ? GO_TO_DASHBOARD()
          : GO_TO_VERIFY_EMAIL()
      }
      next()
    }
  },
  {
    path: '/register',
    name: ROUTES_NAMES.register,
    component: require('./components/layouts/auth/RegisterLayout.vue').default,
    meta: {
      title: "Register",
    },
    beforeEnter(to, from, next) {
      if (vuex.getters.getUser) {
        vuex.getters.getUserMailVerified
          ? GO_TO_DASHBOARD()
          : GO_TO_VERIFY_EMAIL()
      }
      next()
    }
  },
  {
    path: '/verify-email',
    name: ROUTES_NAMES.verify_email,
    component: require('./components/layouts/auth/VerifyEmailLayout.vue').default,
    meta: {
      title: "Verify email",
    },
    beforeEnter(to, from, next) {
      if (!vuex.getters.getUser) {
        GO_TO_LOGIN()
      } else if (vuex.getters.getUser && vuex.getters.getUserMailVerified) {
        GO_TO_DASHBOARD()
      }
      next()
    }
  },
  {
    path: '/forgot-password',
    name: ROUTES_NAMES.forgot_password,
    component: require('./components/layouts/auth/ForgotPasswordLayout.vue').default,
    meta: {
      title: "Forgot password",
    },
    beforeEnter(to, from, next) {
      if (vuex.getters.getUser) {
        GO_TO_DASHBOARD()
      }
      next()
    }
  },
  {
    path: '/forgot-password/:hash',
    name: ROUTES_NAMES.forgot_password_reset,
    component: require('./components/layouts/auth/ForgotPasswordLayout.vue').default,
    meta: {
      title: "Change your password",
    },
    beforeEnter(to, from, next) {
      if (vuex.getters.getUser) {
        GO_TO_DASHBOARD()
      }
      next()
    }
  },
  {
    path: '/',
    component: require('./components/layouts/DashboardEntryLayout').default,
    meta: {
      auth: true,
    },
    beforeEnter(to, from, next) {
      if (!vuex.getters.getUser) {
        GO_TO_LOGIN(true)
      } else if (!vuex.getters.getUserMailVerified) {
        GO_TO_VERIFY_EMAIL()
      }
      if (!CHECK_USER_ROLE_PERMISSION(to)) {
        GO_TO_DASHBOARD()
      }
      next()
    },
    children: [
      {
        path: '/',
        name: ROUTES_NAMES.dashboard,
        component: require('./components/layouts/DashboardLayout').default,
        meta: {
          title: "Dashboard",
        }
      },
      {
        path: '/my-vacation-calendar',
        name: ROUTES_NAMES.my_vacation_calendar,
        component: require('./components/layouts/MyVacationCalendarLayout').default,
        meta: {
          main_menu: true,
          title: "My vacation calendar",
        }
      },
      {
        path: '/holidays-calendar',
        name: ROUTES_NAMES.public_holidays_calendar,
        component: require('./components/layouts/HolidayCalendarLayout').default,
        meta: {
          setting_menu: true,
          title: "Holidays calendar",
        }
      },
      {
        path: '/users',
        name: ROUTES_NAMES.users,
        component: require('./components/layouts/User/UsersLayout.vue').default,
        meta: {
          setting_menu: true,
          title: "Users",
        }
      },
      {
        path: '/document',
        name: ROUTES_NAMES.document,
        component: require('./components/layouts/documents/DocumentsLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "Documents",
        }
      },
      {
        path: '/document/:id',
        name: ROUTES_NAMES.editDocument,
        component: require('./components/layouts/documents/DocumentView.vue').default,
        meta: {
          title: "Document",
          parent: ROUTES_NAMES.document
        },
      },
      {
        path: '/document-categories',
        name: ROUTES_NAMES.document_categories,
        component: require('./components/layouts/documents/DocumentCategoriesLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "DocumentCategories",
          sub_item_of: 'articles',
        },
      },
      {
        path: '/document-categories/:id',
        name: ROUTES_NAMES.editDocumentCategory,
        component: require('./components/layouts/documents/DocumentCategoryView.vue').default,
        meta: {
          title: "DocumentCategory",
          parent: ROUTES_NAMES.document_categories
        },
      },
      {
        path: '/statistic',
        name: ROUTES_NAMES.statistic,
        component: require('./components/layouts/StatisticLayout').default,
        meta: {
          setting_menu: true,
          title: "Statistic",
        }
      },
      {
        path: '/user/:id',
        name: ROUTES_NAMES.user,
        component: require('./components/layouts/User/UserLayout.vue').default,
        meta: {
          main_menu: false,
          title: "User",
          parent: ROUTES_NAMES.users
        }
      },
      {
        path: '/user/equipment/:id',
        name: ROUTES_NAMES.user_equipment,
        component: require('./components/layouts/User/EquipmentView.vue').default,
        meta: {
          main_menu: false,
          title: "User equipment",
          parent: ROUTES_NAMES.users
        }
      },
      {
        path: '',
        name: ROUTES_NAMES.benefit_parent,
        meta: {
          setting_menu: true,
          title: "Benefits",
          parent_of: [
            ROUTES_NAMES.benefit_packages,
            ROUTES_NAMES.benefit_cookies
          ],
          hidden: true,
        }
      },
      {
        path: '/benefit-packages',
        name: ROUTES_NAMES.benefit_packages,
        component: require('./components/layouts/belts/BenefitsLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "Benefits",
          sub_item_of: 'benefits',
        }
      },
      {
        path: '/benefit-cookies',
        name: ROUTES_NAMES.benefit_cookies,
        component: require('./components/layouts/belts/CookiesLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "Cookies",
          sub_item_of: 'benefits',
        }
      },
      {
        path: '/benefit-package/:id',
        name: ROUTES_NAMES.benefit_package,
        component: require('./components/layouts/belts/BenefitPackageLayout.vue').default,
        meta: {
          main_menu: false,
          title: "Benefit",
          parent: ROUTES_NAMES.benefit_packages
        }
      },
      {
        path: '/benefit-cookie/:id',
        name: ROUTES_NAMES.benefit_cookie,
        component: require('./components/layouts/belts/CookieView.vue').default,
        meta: {
          setting_menu: false,
          title: "Cookies",
          parent: ROUTES_NAMES.benefit_cookies
        }
      },
      {
        path: '/belt-benefit/:id',
        name: ROUTES_NAMES.belt_benefit,
        component: require('./components/layouts/belts/BeltBenefitLayout.vue').default,
        meta: {
          main_menu: false,
          title: "Belt benefit",
          parent: ROUTES_NAMES.benefit_packages
        }
      },
      {
        path: '/profile',
        name: ROUTES_NAMES.profile,
        component: require('./components/layouts/User/ProfileLayout.vue').default,
        meta: {
          main_menu: false,
          title: "Profile",
        }
      },
      {
        path: '/my-committee',
        name: ROUTES_NAMES.my_committee,
        component: require('./components/layouts/MyCommitteeLayout').default,
        meta: {
          main_menu: true,
          title: "My team",
          manager: true
        },
      },
      {
        path: '/committees',
        name: ROUTES_NAMES.committees,
        component: require('./components/layouts/CommitteesLayout').default,
        meta: {
          setting_menu: true,
          title: "Committees",
        },
      },
      {
        path: '/committee/:id',
        name: ROUTES_NAMES.committee,
        component: require('./components/layouts/CommitteeView').default,
        meta: {
          title: "Committee",
          parent: ROUTES_NAMES.committees
        },
      },
      {
        path: '/company-equipments',
        name: ROUTES_NAMES.company_equipments,
        component: require('./components/layouts/CompanyEquipmentLayout.vue').default,
        meta: {
          setting_menu: true,
          title: "Company equipments",
        },
      },
      {
        path: '/company-equipment/:id',
        name: ROUTES_NAMES.company_equipment,
        component: require('./components/layouts/CompanyEquipmentView.vue').default,
        meta: {
          title: "Company equipment",
          parent: ROUTES_NAMES.company_equipments
        },
      },
      {
        path: '',
        name: ROUTES_NAMES.articles_parent,
        meta: {
          setting_menu: true,
          title: "Articles",
          parent_of: [
            ROUTES_NAMES.articles,
            ROUTES_NAMES.article_categories
          ],
          hidden: true,
        }
      },
      {
        path: '',
        name: ROUTES_NAMES.documents_parent,
        meta: {
          setting_menu: true,
          title: "Documents",
          parent_of: [
            ROUTES_NAMES.document,
            ROUTES_NAMES.document_categories
          ],
          hidden: true,
        }
      },
      {
        path: '/articles',
        name: ROUTES_NAMES.articles,
        component: require('./components/layouts/blog/ArticlesLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "Articles",
          sub_item_of: 'articles',
        },
      },
      {
        path: '/articles/:id',
        name: ROUTES_NAMES.editArticle,
        component: require('./components/layouts/blog/ArticleView.vue').default,
        meta: {
          title: "Article",
          parent: ROUTES_NAMES.articles
        },
      },
      {
        path: '/article-categories',
        name: ROUTES_NAMES.article_categories,
        component: require('./components/layouts/blog/ArticleCategoriesLayout.vue').default,
        meta: {
          setting_menu: false,
          title: "ArticleCategories",
          sub_item_of: 'articles',
        },
      },
      {
        path: '/article-categories/:id',
        name: ROUTES_NAMES.editArticleCategory,
        component: require('./components/layouts/blog/ArticleCategoryView.vue').default,
        meta: {
          title: "ArticleCategory",
          parent: ROUTES_NAMES.article_categories
        },
      },
      {
        path: '/blog',
        name: ROUTES_NAMES.blog,
        component: require('./components/layouts/blog/ArticlesUserLayout.vue').default,
        meta: {
          main_menu: true,
          title: "Blog"
        },
      },
      {
        path: '/files',
        name: ROUTES_NAMES.files,
        component: require('./components/layouts/documents/DocumentsUserLayout.vue').default,
        meta: {
          main_menu: true,
          title: "Files"
        },
      },
      {
        path: '/article/:id',
        name: ROUTES_NAMES.article,
        component: require('./components/layouts/blog/ArticleUserView.vue').default,
        meta: {
          title: "Article",
          parent: ROUTES_NAMES.blog
        },
      },
      {
        path: '/daily-report',
        name: ROUTES_NAMES.daily_report,
        component: require('./components/layouts/DailyReportLayout').default,
        meta: {
          setting_menu: true,
          title: "Daily report",
        },
      },
      {
        path: '/export',
        name: ROUTES_NAMES.export,
        component: require('./components/layouts/ExportLayout').default,
        meta: {
          setting_menu: true,
          title: "Export",
        },
      },
      {
        path: '/trash',
        name: ROUTES_NAMES.trash,
        component: require('./components/layouts/settings/TrashLayout.vue').default,
        meta: {
          setting_menu: true,
          title: "Trash",
        },
      },
      {
        path: '/trash/:id',
        name: ROUTES_NAMES.trashed,
        component: require('./components/layouts/settings/TrashedLayout.vue').default,
        meta: {
          title: "Trashed",
          parent: ROUTES_NAMES.trash
        },
      },
    ],
  },
  {
    path: '*',
    name: ROUTES_NAMES.page_404,
    component: require('./components/layouts/NotFoundComponent').default,
    meta: {
      title: "404 Not found",
      is_404: true,
    }
  }
]
// fill locale variable to routes
fillRouteFlatten(ROUTES).map(route => {
  if (route.children || route.name === ROUTES_NAMES.page_404 || !route.name) return
  route.path = `/:${LOCALE_PARAM}${route.path}`
})

// init router
const ROUTER = new VueRouter({
  mode: 'history',
  routes: ROUTES,
})

ROUTER.beforeEach((to, from, next) => {
  vuex.dispatch('actionProgressBarStatus', true)
  next()
})

ROUTER.afterEach((to) => {
  changeTitleBasedOnRoute(to.matched)
  setTimeout(() => {
    ROUTER.app.$store.dispatch('actionProgressBarStatus', false)
  }, 0)
  document.querySelectorAll('.tox.tox-silver-sink.tox-tinymce-aux')
    .forEach(tox_box => tox_box.outerHTML = '')
})

export default ROUTER;

export const MAIN_MENU = fillRouteFlatten(ROUTES).filter(menu => menu.meta?.main_menu);
export const SETTING_MENU = fillRouteFlatten(ROUTES).filter(menu => menu.meta?.setting_menu);

export const FROM_PAGE = () => {
  return encodeURIComponent(`${location.pathname}${location.search}`)
}

export const GET_PARAMS_ROUTE_PARAMS = (data = null) => {
  let params = {...data}
  if (data && Object.keys(data).length) {
    params = {...data}
  }
  params[LOCALE_PARAM] = vuex.getters.getSelectedLanguage
  return params
}

function changeTitleBasedOnRoute(matched) {
  let head_title = document.head.querySelector('title')
  if (!head_title) return
  let title_text = head_title?.dataset?.title || 'OCR'
  let matched_title = matched.find(el => el.meta?.title || el.meta?.name)
  matched_title = matched_title.meta?.title || matched_title.meta?.name || ''
  head_title.innerText = `${matched_title} | ${title_text}`
}

function fillRouteFlatten(list) {
  if (!Array.isArray(list)) return []
  let local_list = []
  list.forEach(el => {
    if (el.children && el.children.length) {
      local_list = local_list.concat(fillRouteFlatten(el.children))
    } else {
      local_list.push(el)
    }
  })
  return local_list
}

const checkPopstateLocaleChange = () => {
  let lang = GET_LOCALE_FIRST_PART()
  if (!LANGUAGE_LIST.includes(lang) || lang === vuex.getters.getSelectedLanguage) return
  vuex.dispatch('actionChangeLocale', {vue: ROUTER.app, lang: lang, push_state: false})
}

const CHECK_USER_ROLE_PERMISSION = (route) => {
  if (!route.path == '/' && vuex.getters.getUserRoleIsNewUser) {
    return false;
  }
  if (route.meta.manager) {
    return Boolean(vuex.getters.getUserIsManager)
  }
  return vuex.getters.getUserRoleIsAdmin
    || [ROUTES_NAMES.dashboard, ROUTES_NAMES.login, ROUTES_NAMES.page_404].includes(route.name)
    || (route.meta.role || []).includes(vuex.getters.getUserRoleName)
}

export const GO_TO_DASHBOARD = () => {
  ROUTER.push({
    name: ROUTES_NAMES.dashboard,
    params: GET_PARAMS_ROUTE_PARAMS(),
  })
}

export const GO_TO_LOGIN = (with_redirect_params = false) => {
  let query = {}
  if (with_redirect_params) {
    query = {
      from_page: FROM_PAGE()
    }
  }
  ROUTER.push({
    name: ROUTES_NAMES.login,
    params: GET_PARAMS_ROUTE_PARAMS(),
    query: query,
  })
}

export const GO_TO_VERIFY_EMAIL = () => {
  ROUTER.push({
    name: ROUTES_NAMES.verify_email,
    params: GET_PARAMS_ROUTE_PARAMS(),
  })
}

window.addEventListener('popstate', checkPopstateLocaleChange)
